<template>
  <v-btn-toggle v-model="currValue" @change="changeBtnToggle" dark class="btnToggle">
    <v-btn v-for="(item,index) in btnList" :key="index" :value="item.value" :style="{'width':btnWidth+'px'}">
      <p>{{item.text}}</p>
    </v-btn>
  </v-btn-toggle>

</template>

<script>
export default {
  name: "SmallBtnToggle",
  model:{
    prop:"value",//用来接收 父组件 传给子组件的值
    event:"number-event" //用来触发的事件
  },
  props:["value","btnList","btnWidth"],
  data(){
    return{
      currValue:this.value

    }
  },
  watch:{
    value(){
      this.currValue = this.value
    }
  },
  methods:{
    changeBtnToggle(){
      this.$emit("number-event",this.currValue);
    }
  }



}
</script>


<style>

/*按钮组*/
.btnToggle{
  height:27px;
  border-radius:2px;
}
.btnToggle .v-btn{
  min-width:0 !important;
  /*width:26px;*/
  height:100% !important;
  font-size:13px;
  border-radius:2px;
}
.btnToggle .v-btn--active{
  background:#ff0000;
}

</style>